<template>
  <main id="page-wrap" class="createad">
    <div class="grid-container">
      <div class="grid-x grid-margin-x">
        <div class="cell small-12 medium-4 show-for-medium">
          <div sticky-container class="sticky-container create-sidebar">
            <div
              v-sticky
              sticky-offset="offset"
              sticky-side="top"
              class="sticky-inner">
              <aside class="sidebar-wrap">
                <div class="sidebar-content">
                  <section class="highlight-box">
                    <header>
                      <svg xmlns="http://www.w3.org/2000/svg" width="57" height="56"><path fill-rule="evenodd" d="M27.130246 30.460861l6.44827-6.44827c.644365-.644365 1.689088-.644365 2.333453 0l.053033.053033c.644365.644365.644365 1.689087 0 2.333452l-7.566043 7.566043c-.004106.004106-.008228.008186-.012367.012239-.00401.004095-.008047.008175-.01211.012237-.630846.630847-1.653651.630847-2.284498 0l-4.079463-4.079462c-.630847-.630847-.630847-1.653652 0-2.284499.630847-.630847 1.653652-.630847 2.284499 0l2.835226 2.835227zm29.36962-2.460811c0 1.895828-.492186 3.682284-1.476558 5.359362-.984373 1.677079-2.3151 2.989576-3.992178 3.937491.510416 1.895828.528644 3.773428.054687 5.632799-.473957 1.859371-1.403642 3.481762-2.789056 4.867176s-3.007805 2.315099-4.867176 2.789056c-1.85937.473956-3.700511.455728-5.523424-.054688-1.020831 1.677079-2.369787 3.007806-4.046866 3.992178-1.677078.984373-3.463534 1.476559-5.359362 1.476559-1.895828 0-3.682283-.492186-5.359362-1.476559-1.677079-.984372-2.989576-2.315099-3.937491-3.992178-1.822912.510416-3.682283.528644-5.578111.054688-1.895829-.473957-3.53645-1.403642-4.921864-2.789056-1.385413-1.385414-2.315099-3.007805-2.789055-4.867176-.473957-1.859371-.455729-3.736971.054687-5.632799-1.677079-.947915-3.007805-2.260412-3.992178-3.937491C.992186 31.682334.5 29.895878.5 28.00005c0-1.895828.492186-3.682283 1.476559-5.359362.984373-1.677079 2.315099-3.026035 3.992178-4.046866-.510416-1.822912-.528644-3.664053-.054687-5.523424.473956-1.85937 1.403642-3.481762 2.789055-4.867176 1.385414-1.385414 3.007806-2.315099 4.867176-2.789056 1.859371-.473956 3.736971-.455728 5.632799.054688.947915-1.677079 2.260412-3.007806 3.937491-3.992178C24.81765.492303 26.604105.000117 28.499933.000117c1.895828 0 3.682284.492186 5.359362 1.476559 1.677079.984372 3.026035 2.315099 4.046866 3.992178 1.822913-.510416 3.664054-.528644 5.523424-.054688 1.859371.473957 3.481762 1.403642 4.867176 2.789056s2.315099 3.007806 2.789056 4.867176c.473957 1.859371.455729 3.736971-.054687 5.632799 1.677078.947915 3.007805 2.260412 3.992178 3.937491.984372 1.677079 1.476558 3.463534 1.476558 5.359362zm-9.953101 7.437482l.328124-.109374c4.083323-1.385414 6.124986-3.828116 6.124986-7.328108 0-2.260412-.802081-4.046865-2.406244-5.359362-.874998-.729166-2.114578-1.385414-3.718742-1.968745l-.328124-.109375.109375-.328124c1.968745-3.864574 1.677079-7.036441-.874998-9.515603-1.531246-1.604163-3.354159-2.333327-5.468737-2.187495-1.166664.145833-2.515619.583332-4.046865 1.312497l-.328124.109375-.109375-.328124c-1.385414-4.083323-3.828116-6.124986-7.328108-6.124986-2.260412 0-4.046865.802081-5.359362 2.406245-.729165.874998-1.385414 2.114577-1.968745 3.718741l-.109375.328124-.328124-.109375c-3.864574-1.895828-7.036441-1.604163-9.515603.874998C9.614561 12.250088 8.885397 14.073 9.03123 16.187578c.145832 1.166665.583331 2.515619 1.312497 4.046866l.109374.328124-.328124.109375c-4.083323 1.385413-6.124985 3.828115-6.124985 7.328107 0 2.260412.802081 4.046865 2.406244 5.359362.874998.729166 2.114578 1.385414 3.718741 1.968746l.328124.109374-.109374.328125c-1.968746 3.864573-1.677079 7.036441.874997 9.515602 1.385414 1.458329 2.953118 2.187495 4.703114 2.187495 1.312497 0 3.026035-.473957 5.140613-1.421872l.109375.328124c1.385414 4.083323 3.828116 6.124986 7.328107 6.124986 2.260412 0 4.046866-.802081 5.359362-2.406245.729166-.874998 1.385414-2.114577 1.968746-3.718741l.109375-.328124c2.114577.947915 3.828115 1.421872 5.140612 1.421872 1.749996 0 3.3177-.729166 4.703114-2.187495 1.604163-1.531246 2.333327-3.354159 2.187495-5.468737-.145833-1.166665-.583332-2.515619-1.312497-4.046865-.072917-.145833-.109375-.255208-.109375-.328125z" /></svg>
                      <h2>Behöver du hjälp?</h2>
                      <p>Maila oss på <nobr><a href="mailto:info@bytbostad.se">info@bytbostad.se</a></nobr></p>
                    </header>
                  </section>
                </div>
              </aside>
            </div>
          </div>
        </div>

        <!-- TODO: Styla boxarna -->
        <div class="cell small-12 medium-8">
          <div class="grid-x grid-margin-x">
            <!-- Medlems-registrering -->
            <div class="cell small-12 startgrid" style="margin-bottom:20px">


              <!-- <div style="padding:0.5rem;background-color:#F5F7F9;border-radius:0.25rem;font-size:1.1rem;">
                <p><strong>OBS:</strong> För att kunna använda BytBostad måste du ha ett förstahandskontrakt att byta bort.</p>
              </div> -->


              <h2 style="padding-bottom: 1rem;">Dina uppgifter</h2>

              <FBButton v-if="!user" />

              <!-- {{ user }} -->
              <RegistrationBox v-if="user" />
              
            </div>

            <template v-if="!myAds.length && user">
              <!-- <div class="cell small-12">
                <h2 v-if="type!=21">
                  Bostaden du vill byta bort
                </h2>
                <h2 v-if="type==21">
                  Bostäderna du vill byta bort
                </h2>
              </div> -->

              <!--
              <div class="cell small-12 medium-4 highlight-box ad-type" :class="{active: type==11}" @click="type = 11">
                <h3>1 mot 1</h3>
                <h1>🏠 ➡ 🏠</h1>
                <p>Jag har en bostad och jag vill byta den mot en bostad.</p>
              </div>

              <div class="cell small-12 medium-4 highlight-box ad-type" :class="{active: type==12}" @click="type=12">
                <h3>1 mot 2</h3>
                <h1>🏠 ➡ 🏠🏠</h1>
                <p>Jag har en bostad som jag vill byta mot två bostäder.</p>
              </div>

              <div class="cell small-12 medium-4 highlight-box ad-type" :class="{active: type==21}" @click="type=21">
                <h3>2 mot 1</h3>
                <h1>🏠🏠 ➡ 🏠</h1>
                <p>Jag har två bostäder som jag vill byta mot en bostad.</p>
              </div> -->
            </template>
          </div>

          <AdForm v-if="!myAds.length && user" :ad-type="type" />

          <div v-if="myAds.length">
            <h1>Du kan bara ha en annons</h1>
            <MyAdList :ads="myAds" />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import AdForm from '@/components/AdForm.vue'
import MyAdList from '@/components/MyAdList.vue'
import RegistrationBox from '@/components/RegistrationBox.vue'
import FBButton from '@/components/FBButton.vue'

export default {
  components: {
    // AdCard,
    AdForm,
    MyAdList,
    RegistrationBox,
    FBButton
  },

  data() {
    return {
      type: 11,
      ad: {},
      offset: {
        top: 114,
        bottom: 100
      },

    }
  },

  computed: {
    ...mapState(['categories']),
    ...mapGetters(['token', 'user', 'myAds'])
  },

  mounted() {
    // this.$store.dispatch('getMyAds')

    if (this.user && !this.myAds.length) {
      this.$store.dispatch('getMyAds')
      .catch(error => {
        Sentry.captureException(error);
      })
      // .then(
      //   response => {
      //     // console.log(response)
      //   },
      //   error => {
      //     Sentry.captureException(error);
      //     // console.log(error)
      //   }
      // )
    }
  },
  methods: {
    adDetails(ad) {
      this.ad = ad
    }
  },

  metaInfo() {
    return { title: 'Skapa annons - BytBostad' }
  }
}
</script>
<style lang="scss" scoped>
@import '@/scss/abstracts/_variables.scss';

#page-wrap{padding:50px 0px 100px 0px;}

//TODO: Style
.ad-type{
  color:#5E5E5E;
  padding:15px;
  cursor: pointer;
  border-color:#f6f6f6;
}

.ad-type.active{
  border-color: $color-secondary;

}
.ad-type.active h1{
  color: $color-secondary;

}

.ad-type h1, .ad-type h3{
  text-align:center;
}

.startgrid{
  display:grid;
  // justify-content: center;
  // align-content: center;;
}
</style>
